import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, NgModule, EventEmitter, Output } from '@angular/core';
import * as i3$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClientModule } from '@angular/common/http';
import Swal from 'sweetalert2';
import { tap, catchError, delay } from 'rxjs/operators';
import { of } from 'rxjs';
import { format } from 'date-fns';
import * as i3 from '@ng-bootstrap/ng-bootstrap';
import * as i3$2 from '@angular/forms';
import { FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
function RgpdComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.html, i0.ɵɵsanitizeHtml);
  }
}
function RgpdComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "textarea", 11);
    i0.ɵɵtwoWayListener("ngModelChange", function RgpdComponent_div_4_Template_textarea_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.description, $event) || (ctx_r0.description = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.translateList[4], ":");
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.description);
  }
}
function RgpdComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "span", 14);
    i0.ɵɵtext(3, "Loading...");
    i0.ɵɵelementEnd()()();
  }
}
function CardsComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 12);
    i0.ɵɵtext(2, "Loading...");
    i0.ɵɵelementEnd()();
  }
}
function CardsComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.translateList[5], " ");
  }
}
function CardsComponent_li_10_strong_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.translateList[7]);
  }
}
function CardsComponent_li_10_strong_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.translateList[8]);
  }
}
function CardsComponent_li_10_label_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 22);
    i0.ɵɵlistener("click", function CardsComponent_li_10_label_8_Template_label_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.removeCard());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.translateList[2]);
  }
}
function CardsComponent_li_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 14)(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "small");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtemplate(6, CardsComponent_li_10_strong_6_Template, 2, 1, "strong", 17)(7, CardsComponent_li_10_strong_7_Template, 2, 1, "strong", 18)(8, CardsComponent_li_10_label_8_Template, 2, 1, "label", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const card_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ctx_r0.cardBrand(card_r3.cardBrand), " ", ctx_r0.translateList[6], " ", card_r3.cardNumber, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Cad. ", card_r3.expireDate, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", card_r3.isActive);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !card_r3.isActive);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", card_r3.isActive);
  }
}
function CardsComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "form", 23);
    i0.ɵɵelement(2, "input", 24)(3, "input", 25)(4, "input", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("action", ctx_r0.redsysData.action, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("value", ctx_r0.redsysData.hidden.Ds_SignatureVersion);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("value", ctx_r0.redsysData.hidden.Ds_MerchantParameters);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("value", ctx_r0.redsysData.hidden.Ds_Signature);
  }
}
function ReferralComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.translateList[3]);
  }
}
function ReferralComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 9);
    i0.ɵɵtext(2, "Loading...");
    i0.ɵɵelementEnd()();
  }
}
function ReferralComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.translateList[1]);
  }
}
function ReferralComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.referral.description);
  }
}
var CardBrand = /*#__PURE__*/function (CardBrand) {
  CardBrand["VISA"] = "1";
  CardBrand["MASTERCARD"] = "2";
  CardBrand["DINERS"] = "6";
  CardBrand["PRIVADA"] = "7";
  CardBrand["AMEX"] = "8";
  CardBrand["JCB"] = "9";
  CardBrand["UPI"] = "22";
  CardBrand["DEFAULT"] = "Unknown";
  return CardBrand;
}(CardBrand || {});
let RGPDService = /*#__PURE__*/(() => {
  class RGPDService {
    constructor(http, hipermercodeToolkitService) {
      this.http = http;
      this.hipermercodeToolkitService = hipermercodeToolkitService;
    }
    /**
      * @region RGPD
      */
    getRGPD(jwt) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt ? jwt : this.hipermercodeToolkitService.getJwt()}`
      });
      return this.http.get(`${this.hipermercodeToolkitService.getDomainUrl()}/rgpd/show`, {
        headers: headers,
        observe: 'response',
        responseType: 'text'
      });
    }
    unsubscribeRGPD(description, jwt) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt ? jwt : this.hipermercodeToolkitService.getJwt()}`
      });
      const payload = {
        description: description ? description : ''
      };
      return this.http.post(`${this.hipermercodeToolkitService.getDomainUrl()}/rgpd/accept`, payload, {
        headers: headers
      });
    }
    static {
      this.ɵfac = function RGPDService_Factory(t) {
        return new (t || RGPDService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HipermercodeToolkitService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RGPDService,
        factory: RGPDService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RGPDService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RgpdComponent = /*#__PURE__*/(() => {
  class RgpdComponent {
    constructor(rgpdService, hipermercodeToolkitService, modalService) {
      this.rgpdService = rgpdService;
      this.hipermercodeToolkitService = hipermercodeToolkitService;
      this.modalService = modalService;
      this.language = 'es-ES';
      this.translateList = [];
      this.language = this.hipermercodeToolkitService.getLanguage();
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    ngOnInit() {
      this.getTranslates();
      this.getRGPD();
    }
    unsubscribeAccount() {
      this.rgpdService.unsubscribeRGPD(this.description).pipe(tap(() => {
        const date = format(new Date(), 'dd/MM/yyyy HH:MM');
        localStorage.setItem('RGPD', date);
        Swal.fire(this.translateList[1], this.translateList[2], 'success');
        this.modalService.close();
      }), catchError(() => {
        Swal.fire('Error', this.translateList[3], 'error');
        return of(null);
      })).subscribe();
    }
    closeModal() {
      this.modalService.close();
    }
    getRGPD() {
      this.subscription = this.rgpdService.getRGPD().pipe(tap(response => this.html = response.body)).subscribe();
    }
    getTranslates() {
      this.translateList = [this.language === 'es-ES' ? 'Darse de baja' : 'Unsubscribe', this.language === 'es-ES' ? 'Te diste de baja' : 'You unsubscribed', this.language === 'es-ES' ? 'Te esperamos pronto' : 'We hope to see you soon', this.language === 'es-ES' ? 'Vuelve a intentarlo más tarde' : 'Try again later', this.language === 'es-ES' ? 'Déjanos un comentario' : 'Leave a comment'];
    }
    static {
      this.ɵfac = function RgpdComponent_Factory(t) {
        return new (t || RgpdComponent)(i0.ɵɵdirectiveInject(RGPDService), i0.ɵɵdirectiveInject(HipermercodeToolkitService), i0.ɵɵdirectiveInject(i3.NgbActiveModal));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RgpdComponent,
        selectors: [["hc-toolkit-rgpd"]],
        decls: 9,
        vars: 4,
        consts: [[1, "modal-header"], ["type", "button", "aria-label", "Close", 1, "btn-close", 3, "click"], [1, "modal-body"], ["class", "html-visor", 3, "innerHTML", 4, "ngIf"], ["class", "mt-3", 4, "ngIf"], ["class", "d-flex justify-content-center", 4, "ngIf"], [1, "p-2", "d-flex", "m-3", "align-items-end", "justify-content-end"], [1, "btn", "btn-danger", "flex-end", 3, "click"], [1, "html-visor", 3, "innerHTML"], [1, "mt-3"], ["for", "exampleFormControlTextarea1", 1, "form-label"], ["id", "exampleFormControlTextarea1", "rows", "3", 1, "form-control", 3, "ngModelChange", "ngModel"], [1, "d-flex", "justify-content-center"], ["role", "status", 1, "spinner-border", "text-primary", "mt-5"], [1, "visually-hidden"]],
        template: function RgpdComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function RgpdComponent_Template_button_click_1_listener() {
              return ctx.closeModal();
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, RgpdComponent_div_3_Template, 1, 1, "div", 3)(4, RgpdComponent_div_4_Template, 4, 2, "div", 4)(5, RgpdComponent_div_5_Template, 4, 0, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6)(7, "button", 7);
            i0.ɵɵlistener("click", function RgpdComponent_Template_button_click_7_listener() {
              return ctx.unsubscribeAccount();
            });
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.html);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.html);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.html);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.translateList[0]);
          }
        },
        dependencies: [i3$1.NgIf, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.NgModel],
        styles: [".html-visor[_ngcontent-%COMP%]{max-height:300px;overflow-y:auto}"]
      });
    }
  }
  return RgpdComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HipermercodeToolkitService = /*#__PURE__*/(() => {
  class HipermercodeToolkitService {
    constructor(env, modalService) {
      this.env = env;
      this.modalService = modalService;
      this.jwt = null;
      this.language = 'es-ES';
    }
    getJwt() {
      return this.jwt;
    }
    setJwt(jwt) {
      this.jwt = jwt;
    }
    removeJwt() {
      this.jwt = null;
    }
    getDomainUrl() {
      return this.domainUrl || this.env.server?.platform;
    }
    setDomainUrl(domainUrl) {
      this.domainUrl = domainUrl;
    }
    removeDomainUrl() {
      this.domainUrl = null;
    }
    getLanguage() {
      return this.language;
    }
    setLanguage(language) {
      this.language = language;
    }
    getRgpdDate() {
      return localStorage.getItem('RGPD');
    }
    async openRgpdModal() {
      const response = await this.modalService.open(RgpdComponent, {
        size: 'lg',
        backdrop: 'static'
      }).result;
      return response;
    }
    static {
      this.ɵfac = function HipermercodeToolkitService_Factory(t) {
        return new (t || HipermercodeToolkitService)(i0.ɵɵinject('env'), i0.ɵɵinject(i3.NgbModal));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HipermercodeToolkitService,
        factory: HipermercodeToolkitService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HipermercodeToolkitService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardsService = /*#__PURE__*/(() => {
  class CardsService {
    constructor(http, hipermercodeToolkitService) {
      this.http = http;
      this.hipermercodeToolkitService = hipermercodeToolkitService;
    }
    getCards(companyId, jwt) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt ? jwt : this.hipermercodeToolkitService.getJwt()}`
      });
      return this.http.get(`${this.hipermercodeToolkitService.getDomainUrl()}/company/card/${companyId}`, {
        headers: headers
      });
    }
    addCard(companyId, jwt) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt ? jwt : this.hipermercodeToolkitService.getJwt()}`
      });
      return this.http.post(`${this.hipermercodeToolkitService.getDomainUrl()}/company/card/${companyId}`, {}, {
        headers: headers
      });
    }
    deleteCard(companyId, jwt) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt ? jwt : this.hipermercodeToolkitService.getJwt()}`
      });
      return this.http.delete(`${this.hipermercodeToolkitService.getDomainUrl()}/company/card/${companyId}`, {
        headers: headers
      });
    }
    static {
      this.ɵfac = function CardsService_Factory(t) {
        return new (t || CardsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HipermercodeToolkitService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CardsService,
        factory: CardsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CardsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardsComponent = /*#__PURE__*/(() => {
  class CardsComponent {
    constructor(cardsService, hipermercodeToolkitService) {
      this.cardsService = cardsService;
      this.hipermercodeToolkitService = hipermercodeToolkitService;
      this.language = 'es-ES';
      this.cards = [];
      this.translateList = [];
      this.language = this.hipermercodeToolkitService.getLanguage();
    }
    ngOnInit() {
      this.getTranslates();
      this.getCards();
    }
    addCard() {
      if (this.companyId !== null) {
        this.cardsService.addCard(this.companyId, this.jwt).pipe(catchError(() => {
          Swal.fire('Error', 'Error', 'error');
          return of(null);
        }), tap(response => {
          if (!!response) {
            this.redsysData = response.redsys;
            setTimeout(() => {
              const el = document.getElementById('redsysRedirectForm');
              el.submit();
            }, 200);
          }
        })).subscribe();
      }
    }
    removeCard() {
      Swal.fire({
        icon: 'error',
        title: this.translateList[2],
        text: this.translateList[3],
        confirmButtonText: this.translateList[0],
        showCancelButton: true,
        cancelButtonText: this.translateList[1],
        allowOutsideClick: false
      }).then(result => {
        if (result.isConfirmed) {
          this.tryRemoveCard();
        }
      });
    }
    cardBrand(id) {
      let cardBrand = '';
      switch (id) {
        case CardBrand.VISA:
          cardBrand = 'VISA';
          break;
        case CardBrand.MASTERCARD:
          cardBrand = 'MASTERCARD';
          break;
        case CardBrand.DINERS:
          cardBrand = 'DINERS';
          break;
        case CardBrand.PRIVADA:
          cardBrand = 'PRIVADA';
          break;
        case CardBrand.AMEX:
          cardBrand = 'AMEX';
          break;
        case CardBrand.JCB:
          cardBrand = 'JCB';
          break;
        case CardBrand.UPI:
          cardBrand = 'UPI';
          break;
        default:
          cardBrand = 'UNKNOWN';
          break;
      }
      return cardBrand;
    }
    tryRemoveCard() {
      this.cardsService.deleteCard(this.companyId, this.jwt).pipe(catchError(() => {
        Swal.fire('Error', 'Error', 'error');
        return of(null);
      }), tap(() => {
        this.getCards();
      })).subscribe();
    }
    getCards() {
      this.cardsService.getCards(this.companyId, this.jwt).pipe(tap(response => {
        this.cards = response;
        for (const card of this.cards) {
          card.expireDate = this.formatDate(card.expireDate);
        }
      })).subscribe();
    }
    formatDate(date) {
      return `${date.substring(2, 4)}/${date.substring(0, 2)}`;
    }
    getTranslates() {
      this.translateList = [this.language === 'es-ES' ? 'Aceptar' : 'Accept', this.language === 'es-ES' ? 'Cancelar' : 'Cancel', this.language === 'es-ES' ? 'Eliminar tarjeta' : 'Delete card', this.language === 'es-ES' ? '¿Está seguro?' : 'Are you sure?', this.language === 'es-ES' ? 'Añadir tarjeta' : 'Add card', this.language === 'es-ES' ? 'Todavía no has añadido ninguna tarjeta' : 'You have not added any cards yet', this.language === 'es-ES' ? 'que termina en' : 'ending in', this.language === 'es-ES' ? 'Activa' : 'Active', this.language === 'es-ES' ? 'Inactiva' : 'Inactive'];
    }
    static {
      this.ɵfac = function CardsComponent_Factory(t) {
        return new (t || CardsComponent)(i0.ɵɵdirectiveInject(CardsService), i0.ɵɵdirectiveInject(HipermercodeToolkitService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardsComponent,
        selectors: [["hc-toolkit-cards"]],
        inputs: {
          companyId: "companyId",
          jwt: "jwt"
        },
        decls: 12,
        vars: 5,
        consts: [[1, "d-flex", "justify-content-end", "w-100"], ["type", "button", "aria-label", "Add", 1, "btn", "btn-primary", "p-1", 3, "click"], ["aria-hidden", "true", 1, "p-3", "text-white"], [1, "far", "fa-credit-card", "me-3"], [1, "w-100", "d-flex", "align-items-center", "justify-content-center"], ["class", "spinner-border text-secondary", "role", "status", 4, "ngIf"], ["class", "p-3 small m-2 rounded border", 4, "ngIf"], [1, "modal-body", "py-3"], [1, "list-group"], ["class", "list-group-item", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["role", "status", 1, "spinner-border", "text-secondary"], [1, "sr-only"], [1, "p-3", "small", "m-2", "rounded", "border"], [1, "list-group-item"], [1, "d-flex", "justify-content-between", "mb-2"], [1, "d-flex", "justify-content-between"], ["class", "text-success", 4, "ngIf"], ["class", "text-danger", 4, "ngIf"], ["class", "text-danger cursor-pointer", 3, "click", 4, "ngIf"], [1, "text-success"], [1, "text-danger"], [1, "text-danger", "cursor-pointer", 3, "click"], ["id", "redsysRedirectForm", "name", "from", "method", "POST", 3, "action"], ["type", "hidden", "name", "Ds_SignatureVersion", 3, "value"], ["type", "hidden", "name", "Ds_MerchantParameters", 3, "value"], ["type", "hidden", "name", "Ds_Signature", 3, "value"]],
        template: function CardsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function CardsComponent_Template_button_click_1_listener() {
              return ctx.addCard();
            });
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵelement(3, "i", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtemplate(6, CardsComponent_div_6_Template, 3, 0, "div", 5)(7, CardsComponent_div_7_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 7)(9, "ul", 8);
            i0.ɵɵtemplate(10, CardsComponent_li_10_Template, 9, 7, "li", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, CardsComponent_ng_container_11_Template, 5, 4, "ng-container", 10);
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", ctx.translateList[4], "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.cards === null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.cards.length === 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.cards);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.redsysData);
          }
        },
        dependencies: [i3$1.NgForOf, i3$1.NgIf],
        styles: [".cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}"]
      });
    }
  }
  return CardsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardsModule = /*#__PURE__*/(() => {
  class CardsModule {
    static {
      this.ɵfac = function CardsModule_Factory(t) {
        return new (t || CardsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CardsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, HttpClientModule]
      });
    }
  }
  return CardsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RgpdModule = /*#__PURE__*/(() => {
  class RgpdModule {
    static {
      this.ɵfac = function RgpdModule_Factory(t) {
        return new (t || RgpdModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RgpdModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, HttpClientModule]
      });
    }
  }
  return RgpdModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReferralService = /*#__PURE__*/(() => {
  class ReferralService {
    constructor(http, hipermercodeToolkitService) {
      this.http = http;
      this.hipermercodeToolkitService = hipermercodeToolkitService;
    }
    /**
      * @region Referral
      */
    getReferral(code, jwt) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt ? jwt : this.hipermercodeToolkitService.getJwt()}`
      });
      return this.http.get(`${this.hipermercodeToolkitService.getDomainUrl()}/referral/${code}`, {
        headers: headers
      });
    }
    static {
      this.ɵfac = function ReferralService_Factory(t) {
        return new (t || ReferralService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HipermercodeToolkitService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ReferralService,
        factory: ReferralService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ReferralService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReferralComponent = /*#__PURE__*/(() => {
  class ReferralComponent {
    constructor(referralService, hipermercodeToolkitService, formBuilder) {
      this.referralService = referralService;
      this.hipermercodeToolkitService = hipermercodeToolkitService;
      this.formBuilder = formBuilder;
      this.language = 'es-ES';
      this.referralEvent = new EventEmitter();
      this.referralSubmitted = false;
      this.isChecked = false;
      this.isValid = false;
      this.loading = false;
      this.translateList = [];
      this.referral = null;
      this.language = this.hipermercodeToolkitService.getLanguage();
      this.referralForm = this.formBuilder.group({
        referral: ['', [Validators.required, Validators.minLength(3)]]
      });
      this.referralForm.controls.referral.valueChanges.pipe(delay(200), tap(() => {
        this.referralSubmitted = false;
        this.isValid = false;
        this.isChecked = false;
        this.referralEvent.emit(undefined);
      })).subscribe();
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    ngOnInit() {
      this.getTranslates();
    }
    checkReferral() {
      this.referralSubmitted = true;
      this.isChecked = false;
      this.isValid = false;
      if (this.referralForm.invalid) {
        return;
      }
      this.loading = true;
      const code = this.referralForm.controls.referral.value;
      this.referralService.getReferral(code, this.jwt).pipe(delay(1000), tap(referral => {
        this.loading = false;
        this.isChecked = true;
        this.referral = referral;
        if (referral.description) {
          this.isValid = true;
          this.referralEvent.emit(code);
        } else {
          this.referralEvent.emit(undefined);
        }
      }), catchError(() => {
        this.isChecked = true;
        this.isValid = false;
        this.loading = false;
        this.referral = null;
        this.referralEvent.emit(undefined);
        return of(null);
      })).subscribe();
    }
    getTranslates() {
      this.translateList = [this.language === 'es-ES' ? 'Código de descuento' : 'Discount code', this.language === 'es-ES' ? 'Código no válido' : 'Not valid code', this.language === 'es-ES' ? 'Código válido' : 'Valid code', this.language === 'es-ES' ? 'Aplicar código' : 'Apply code'];
    }
    get fReferral() {
      return this.referralForm.controls;
    }
    static {
      this.ɵfac = function ReferralComponent_Factory(t) {
        return new (t || ReferralComponent)(i0.ɵɵdirectiveInject(ReferralService), i0.ɵɵdirectiveInject(HipermercodeToolkitService), i0.ɵɵdirectiveInject(i3$2.UntypedFormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ReferralComponent,
        selectors: [["hc-toolkit-referral"]],
        inputs: {
          jwt: "jwt"
        },
        outputs: {
          referralEvent: "referralEvent"
        },
        decls: 8,
        vars: 7,
        consts: [[3, "formGroup"], [1, "d-flex"], ["type", "text", "formControlName", "referral", 1, "form-control", 3, "placeholder"], [1, "btn", "btn-success", "ms-2", 3, "click", "disabled"], [4, "ngIf"], ["class", "spinner-border spinner-border-sm text-light", "role", "status", 4, "ngIf"], ["class", "alert alert-danger mt-2", "role", "alert", 4, "ngIf"], ["class", "alert alert-success my-2", "role", "alert", 4, "ngIf"], ["role", "status", 1, "spinner-border", "spinner-border-sm", "text-light"], [1, "visually-hidden"], ["role", "alert", 1, "alert", "alert-danger", "mt-2"], ["role", "alert", 1, "alert", "alert-success", "my-2"]],
        template: function ReferralComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0)(1, "div", 1);
            i0.ɵɵelement(2, "input", 2);
            i0.ɵɵelementStart(3, "button", 3);
            i0.ɵɵlistener("click", function ReferralComponent_Template_button_click_3_listener() {
              return ctx.checkReferral();
            });
            i0.ɵɵtemplate(4, ReferralComponent_span_4_Template, 2, 1, "span", 4)(5, ReferralComponent_div_5_Template, 3, 0, "div", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, ReferralComponent_div_6_Template, 3, 1, "div", 6)(7, ReferralComponent_div_7_Template, 3, 1, "div", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.referralForm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", ctx.translateList[0]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.fReferral.referral.errors || ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.referralSubmitted && ctx.fReferral.referral.errors || ctx.isChecked && !ctx.isValid);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isChecked && ctx.isValid && ctx.referral);
          }
        },
        dependencies: [i3$1.NgIf, i3$2.ɵNgNoValidate, i3$2.DefaultValueAccessor, i3$2.NgControlStatus, i3$2.NgControlStatusGroup, i3$2.FormGroupDirective, i3$2.FormControlName],
        styles: [".btn-success[_ngcontent-%COMP%]{min-width:130px}"]
      });
    }
  }
  return ReferralComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReferralModule = /*#__PURE__*/(() => {
  class ReferralModule {
    static {
      this.ɵfac = function ReferralModule_Factory(t) {
        return new (t || ReferralModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ReferralModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, HttpClientModule]
      });
    }
  }
  return ReferralModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HipermercodeToolkitModule = /*#__PURE__*/(() => {
  class HipermercodeToolkitModule {
    static forRoot(environment) {
      return {
        ngModule: HipermercodeToolkitModule,
        providers: [HipermercodeToolkitService, {
          provide: 'env',
          // you can also use InjectionToken
          useValue: environment
        }]
      };
    }
    static {
      this.ɵfac = function HipermercodeToolkitModule_Factory(t) {
        return new (t || HipermercodeToolkitModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: HipermercodeToolkitModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CardsModule, RgpdModule, ReferralModule, CardsModule, RgpdModule, ReferralModule]
      });
    }
  }
  return HipermercodeToolkitModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of hipermercode-toolkit
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardsComponent, CardsModule, HipermercodeToolkitModule, HipermercodeToolkitService, ReferralComponent, ReferralModule, RgpdComponent, RgpdModule };
